import React, {Component} from 'react';
import '../App.css'
import Slider3 from "../slider/Slider3";
import LogoYear from "../images/pqelogoyear2023.png";
import {Navigate} from "react-router-dom";
class Home extends Component {


    render() {
        const dates = 'January 8th to January 13th.'
        let load = () => {
            if (window.location.href !== 'https://www.pqeconference.com/'){
                console.log('not the right page')
                return <Navigate to={'https://www.pqeconference.com/'} replace={true} />
            }
        }



        load();
        return (

            <div>
                <div className={"MainContent-Wrapper"}>
                    <div className={"Content"}>
                    <h1 className="Main-Title">The 53rd Winter Colloquium on the Physics of Quantum Electronics</h1>


                        <p className="Main-Content">
                            Welcome to the 53rd Winter Colloquium on the Physics of Quantum Electronics.
                        We are happy to announce that we will be holding PQE 2023 will be hosted monday through friday from {dates}
                    </p>

                        <p>The conference Registration fee for PQE-2023 will be $495 prepaid and $545 at the conference.</p>
                        <a className={'Reg-now'} href={'/create'}>Register For PQE-2023</a>

                        <h2 className="LambAward-Title">Lamb Award</h2>
                        <p className="LambAward-Content">The Lamb Award recipients are to be announced</p>

                    </div>
                    <div className={'img-Div'}>
                        <img className={'Logo-Year'} src={LogoYear} alt={"pqelogo"}/>
                    </div>


                </div>
                <div className={'Program-Content-Wrapper'}>
                    <div className={'Program-Content'}>
                    <h2 className={'Main-Title'}>Conference Program</h2>
                    <p className={'Main-Content'}>The Conference Program will be posted on the home page below.
                       Please visit the  <a href={"/Program"}>Program</a> page for more information. </p>
                    </div>
                    <Slider3/>

                </div>



            </div>
        );
    }
}

export default Home;